module.exports = __webpack_public_path__ + "media/rattlesnake.97c35cd0.mp3";